import { Icon } from '@chakra-ui/react';

export const DisciplinaryActionsIconDualTone = (props) => (
  <Icon viewBox="0 0 24 24" boxSize="16px" color="icon.g1" {...props}>
    <g transform="scale(1.41)">
      {' '}
      {/* 24 / 17 ≈ 1.41 */}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.33398 7.5C9.26398 7.5 10.834 5.81786 10.834 3.75C10.834 1.68214 9.26398 0 7.33398 0C5.40398 0 3.83398 1.68214 3.83398 3.75C3.83398 5.81786 5.40398 7.5 7.33398 7.5ZM8.95898 3.75C8.95898 4.90627 8.10871 5.625 7.33398 5.625C6.55926 5.625 5.70898 4.90627 5.70898 3.75C5.70898 2.59373 6.55926 1.875 7.33398 1.875C8.10871 1.875 8.95898 2.59373 8.95898 3.75Z"
        fill="#666666"
      />
      <path
        d="M2.22707 13.0628C2.20908 13.1 2.20898 13.1152 2.20898 13.125H7.10235C7.10235 13.6535 7.23163 14.5342 7.40979 15H0.333984V13.125C0.333984 10.6286 4.99398 9.375 7.33398 9.375H7.83398C7.53846 10.1082 7.43501 10.5247 7.33398 11.25C6.41541 11.25 4.91721 11.5128 3.69589 12.0369C3.08946 12.2971 2.66438 12.5743 2.41765 12.8185C2.3009 12.9341 2.24869 13.018 2.22707 13.0628Z"
        fill="#999999"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.334 12.5C16.334 14.7091 14.5431 16.5 12.334 16.5C10.1248 16.5 8.33398 14.7091 8.33398 12.5C8.33398 10.2909 10.1248 8.5 12.334 8.5C14.5431 8.5 16.334 10.2909 16.334 12.5ZM11.9029 13.1992C11.7809 13.1992 11.6787 13.1107 11.6668 12.9947L11.3351 9.74846C11.3215 9.61533 11.4311 9.5 11.5712 9.5H13.0968C13.2369 9.5 13.3464 9.61533 13.3328 9.74846L13.0011 12.9947C12.9893 13.1107 12.8871 13.1992 12.765 13.1992H11.9029ZM11.3969 14.6566C11.3969 15.1235 11.7906 15.5 12.2789 15.5C12.7671 15.5 13.1609 15.1235 13.1609 14.6566C13.1609 14.1898 12.7671 13.8133 12.2789 13.8133C11.7906 13.7982 11.3969 14.1898 11.3969 14.6566Z"
        fill="#999999"
      />
    </g>
  </Icon>
);
